import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ProviderRpcError } from './errors.js';
/**
 * Takes a provider instance along with events
 * and requests to override and returns an EIP1193 provider
 *
 *  ## Example:
 *
 * *Overriding events: *
 * ```typescript
 * ```
 *
 * @param provider The provider to patch
 * @param requestPatch An `object` with the method to patch
 * and the implementation with which to patch
 * @param events Events to patch
 * @returns An EIP1193 Provider
 */
export var createEIP1193Provider = function createEIP1193Provider(provider, requestPatch) {
  var baseRequest;
  if (provider.request) {
    // Copy the original request method and bind the provider context to it
    baseRequest = provider.request.bind(provider);
  } else if (provider.sendAsync) {
    baseRequest = createRequest(provider);
  }
  var request = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var method, params, key;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            method = _ref.method, params = _ref.params;
            key = method; // If the request method is set to null
            // this indicates this method is not supported
            if (!(requestPatch && requestPatch[key] === null)) {
              _context.next = 4;
              break;
            }
            throw new ProviderRpcError({
              code: 4200,
              message: "The Provider does not support the requested method: ".concat(method)
            });
          case 4:
            if (!(requestPatch && requestPatch[key])) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return", requestPatch[key]({
              baseRequest: baseRequest,
              params: params
            }));
          case 8:
            if (!baseRequest) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", baseRequest({
              method: method,
              params: params
            }));
          case 12:
            throw new ProviderRpcError({
              code: 4200,
              message: "The Provider does not support the requested method: ".concat(method)
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function request(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  provider.request = request;
  return provider;
};
var createRequest = function createRequest(provider) {
  return function (_ref3) {
    var method = _ref3.method,
      params = _ref3.params;
    return new Promise(function (resolve, reject) {
      provider.sendAsync({
        id: 0,
        jsonrpc: '2.0',
        method: method,
        params: params
      }, function (error, _ref4) {
        var result = _ref4.result;
        if (error) {
          reject(JSON.parse(error));
        } else {
          resolve(result == undefined ? null : result);
        }
      });
    });
  };
};